import { AppSettings } from '@/appSettings'
import { DocumentsList } from '@/components/Documents/DocumentsList'
import { Flex, Stack, Text } from '@chakra-ui/react'

const baseUrl = AppSettings.baseUrl + '/docs/uniqa/'

const UniqaContent = () => {
  return (
    <Stack m={4} gap={10}>
      <Documents />
    </Stack>
  )
}

export default UniqaContent



const Documents = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Dokumenty</Text>
      </Flex>

      <Stack gap={16} sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <DocumentsList items={[
          {
            url: baseUrl + 'uniqa_vpp.pdf',
            name: 'Soubor pojistných podmínek',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'uniqa_asistence.pdf',
            name: 'Uniqa Asistence',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'vypoved_prodej.pdf',
            name: 'Výpověď pojištění z důvodu prodeje vozidla',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'das_ucz_15.pdf',
            name: 'Soubor pojistných podmínek D.A.S._15',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'uniqa_ipid.pdf',
            name: 'Informační dokument o pojistném produktu - IPID',
            documentType: 'pdf'
          }
        ]} />
      </Stack>
    </Stack >
  )
}
